import { Box } from "@mui/material";
import { Alert } from "@platform/design-system";
import { useParams } from "react-router";
import { useState } from "react";

import { extractErrorMessage } from "../../utils";
import { useClientRfpsPageDataV2 } from "../../hooks/useClientRfpsPageDataV2";
import { DualRfpsTables } from "../../components/DualRfpsTables";

const Rfps: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const { id } = useParams<{ id: string }>();

  const data = useClientRfpsPageDataV2({ setError, clientId: id ?? "" });

  if (!id) {
    return (
      <Box mt={2} mb={2}>
        <Alert severity="error">Missing route id.</Alert>
      </Box>
    );
  }

  if (error) {
    return (
      <Box mt={2} mb={2}>
        <Alert severity="error">
          {extractErrorMessage(error, "Failed to load client data")}
        </Alert>
      </Box>
    );
  }

  return <DualRfpsTables data={data} />;
};

export { Rfps };
